<template>
  <body>
    <div class="box">
      <div class="weixin" v-if="isWeiXin">
        <p>点击按钮 <br />选择【浏览器中】打开</p>
      </div>
      <!-- <div class="loading" v-if="isStart">
          <div class="ball-scale-multiple">
              <div></div>
              <div></div>
              <div></div>
          </div>
          <div class="page_load">Loading...</div>
      </div> -->
      <div>
        <div class="content" :style="{ height: availHeight + 'px' }">
          <div class="header">
            <div>
              <div>
                <!-- <img src="./imgages2/Group 2643 1@2x.png" alt="" /> -->
                <img v-lazy="$cdnStatic(`/fc/h5/Group 2643 1@2x.png`)" />
              </div>
              <div @click="goServe">
                <!-- <img src="./imgages2/cus service_icon@2x.png" alt="" /> -->
                <img v-lazy="$cdnStatic(`/fc/h5/cus service_icon@2x.png`)" />
              </div>
            </div>
          </div>
          <!-- :autoplay="3000" :autoplay="start" -->
          <van-swipe style="height: 100%" :autoplay="start" @change="onChange">
            <van-swipe-item>
              <div>
                <div class="title3">
                  <!-- <img src="./imgages2/ldy_1@2x.png" alt="" /> -->
                  <img
                    v-lazy="$cdnStatic(`/fc/h5/ldy_1@2x.png`)"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div>
                <div class="title3">
                  <!-- <img src="./imgages2/ldy_2@2x.png" alt="" /> -->
                  <img
                    v-lazy="$cdnStatic(`/fc/h5/ldy_2@2x.png`)"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div>
                <div class="title3">
                  <!-- <img src="./imgages2/ldy_3@2x.png" alt="" /> -->
                  <img
                    v-lazy="$cdnStatic(`/fc/h5/ldy_3@2x.png`)"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- <div class="ios-top" v-if="iosDetect()">
        <img src="./images/logo@3x.png" alt="">
        <div class="right">
          <div class="fix-btn" @click="downloadFix">下载修复工具</div>
          <div>防止iOS掉签闪退打不开</div>
        </div>
      </div> -->
        <div class="android-bottom">
          <!-- 安卓下载 downloadButton2-->
          <div class="download-btn" v-if="!iosDetect()">
            <van-button
              @click="tInstallOpen"
              type="default"
              round
              loading-text="加载中..."
              >立即下载</van-button
            >
          </div>
          <!-- ios下载 -->
          <!-- downloadButton2 downloadButton3 -->
          <div class="download-ios" v-if="iosDetect()">
            <van-button
              @click="refshData"
              type="default"
              round
              loading-text="加载中..."
              v-show="!urlDate.ios_vest_switch"
              >刷新接口</van-button
            >
            <van-button
              @click="rnLoad"
              type="default"
              round
              loading-text="加载中..."
              v-show="urlDate.ios_vest_switch === '1'"
              >{{ urlDate.ios_vest_btn_text }}</van-button
            >
            <van-button
              @click="tInstallOpen"
              type="default"
              round
              loading-text="加载中..."
              v-show="urlDate.ios_mdm_switch === '1'"
              >{{ urlDate.ios_mdm_btn_text }}</van-button
            >
          </div>
          <div class="tip" @click="showTips" v-if="!iosDetect()">
            <p>
              手机报毒无法安装解决办法
              <img src="./images/shang@3x.png" alt="" />
            </p>
          </div>
          <!-- <div class="tip tip-ios" :class="{ abc: showTop }" v-else>
          </div> -->
        </div>
        <!-- android安装说明 -->
        <van-popup v-model="show" position="bottom" round closeable>
          <div class="course_choose" ref="guild" v-if="!iosDetect()">
            <MuanualAnd class="course_and" @choose="choose">
              <template>
                <div class="row" @click="otherPhoneInfoSet(true)">
                  <div class="left">
                    <img src="./images/other@3x.png" alt="" />
                    <p>其他手机</p>
                  </div>
                  <div class="shuoming-btn">说明</div>
                </div>
                <div class="row" @click="choose('其它异常Tips')">
                  <div class="left">
                    <img src="./images/opinstallTips@3x.png" alt="" />
                    <p>安装tips</p>
                  </div>
                  <div class="shuoming-btn">说明</div>
                </div>
                <div class="row" @click="choose('解除风险')">
                  <div class="left">
                    <img src="./images/danger@3x.png" alt="" />
                    <p>解除风险流程</p>
                  </div>
                  <div class="shuoming-btn">说明</div>
                </div>
              </template>
            </MuanualAnd>
          </div>
        </van-popup>
        <!-- ios修复工具说明 -->
        <van-popup
          v-model="showFix"
          position="bottom"
          round
          closeable
          :style="{ height: '90%' }"
        >
          <FixTool></FixTool>
        </van-popup>
        <CoursePhone :viewInfo="courseInfo" />
        <transition name="slide">
          <OtherPhone v-show="otherPhoneShow" @choose="choose" />
        </transition>
        <van-popup v-model="showRn" position="bottom" closeable round>
          <RnDownload
            @downloadRn="downloadRn"
            :RnDate="urlDate"
            :ios16="ios16"
          ></RnDownload>
        </van-popup>
      </div>
    </div>
  </body>
</template>

<script>
import MuanualAnd from "@/interface/manualAnd/ViewCore";
import CoursePhone from "@/interface/CoursePhone/ViewCore";
import OtherPhone from "@/interface/OtherPhone/ViewCore";
import FixTool from "@/interface/FixTool/ViewCore";
import RnDownload from "@/interface/RnDownload/ViewCore";
import "../../libaray/css/screen750.scss";
import "../../libaray/css/loading.scss";
import { iosDetect } from "@/libaray/js/tools";
import axios from "axios";
import config from "../../config/config";
export default {
  components: {
    MuanualAnd,
    CoursePhone,
    OtherPhone,
    FixTool,
    RnDownload,
  },
  data() {
    return {
      isWeiXin: false,
      showRnFour: false,
      show: false,
      courseInfo: {},
      otherPhoneShow: false,
      showFix: false,
      iosDetect,
      aa: require("../../portal/images/1.0.1/zmy_web logo@3x.png"),
      showTop: false,
      start: 0,
      isStart: true,
      currentDate: "",
      iosLink: "https://wnmqe.4337zxywu2.com/YmygVBTO",
      showRn: false,
      urlDate: {},
      ios16: false,
      noSafariDailog: false,
      show_ios_down: false,
      switchNum: 0,
      btnLoading: true,
      pwaStatus: 0,
      mdmStatus: 0,
      rnStatus: 0,
      availHeight: "",
    };
  },
  created() {
    const host =
      location.protocol +
      "//" +
      location.host +
      location.pathname +
      "download.json" +
      "?t=" +
      new Date().getTime();
    fetch(host)
      .then((res) => res.json())
      .then((data) => {
        this.urlDate = data;
        // 如果需要动态马甲包密钥
        if(data.ios_dynamic_key != '') {
          axios.post(`https://38a7618.com/api/v1/keystore/token`, {
            pid: data.ios_dynamic_key
          }).then((reskey) => {
            if (reskey.data.code == 200 && reskey.data.data) {
              this.urlDate.ios_vest_key = '#iPhone#' + reskey.data.data.token + '#iPhone#';
            }
          });
        }
        console.log(data);
        this.matomoFunc();
        // const { android_download_url, ios_download_url, chan_key } = data;
        // window.android_download_url = android_download_url;
        // window.ios_download_url = ios_download_url;
        // window.chan_key = chan_key;
      });
    console.log(host);
    console.log(window.android_download_url);
    console.log(window.screen.availHeight);
    this.availHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    // axios.get(config.host + "/api/config/landing").then((res) => {
    //   if (res.data.code === 200) {
    //     this.urlDate = res.data.data;
    //     this.rnStatus = res.data.data.ldy_rn_status;
    //     console.log(this.urlDate, "888888");
    //   } else {
    //     this.$toast.fail("加载失败，请刷新重试！");
    //   }
    // });
    // 埋点
    this.$sensors.track("LandingPage", {
      method: "view",
    });
  },
  async mounted() {
    // 判断是否是微信浏览器/qq内置浏览器
    var ua = navigator.userAgent.toLowerCase();
    if (
      ua.match(/MicroMessenger/i) == "micromessenger" ||
      ua.match(/QQ/i) == "qq"
    ) {
      this.isWeiXin = true;
    } else {
      this.isWeiXin = false;
    }
    // 不是safari浏览器提示
    var is_safari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") == -1 &&
      navigator.userAgent.indexOf("FxiOS") == -1;
    if (!is_safari) {
      this.noSafariDailog = true;
    }
    // setTimeout(() => {
    //   this.isStart = false
    // }, 1000);
    this.startPlay();
    this.handDisp();
    this.updateCourseInfo({
      applogo: this.aa,
      appName: `反差百科`,
    });
  },
  methods: {
    refshData() {
      axios.get(config.host + "/api/config/landing").then((res) => {
        if (res.data.code === 200) {
          this.urlDate = res.data.data;
          this.rnStatus = res.data.data.ldy_rn_status;
        } else {
          this.$toast.fail("加载失败，请刷新重试！");
        }
      });
    },
    goServe() {
      window.location.href = "https://qqcfaq.com/fcbke/servicemeiqia.html";
    },
    onChange(index) {
      if (index == 2) {
        this.showTop = true;
      } else {
        this.showTop = false;
      }
    },
    startPlay() {
      this.start = 3000;
    },
    downloadFix() {
      this.showFix = true;
    },
    rnLoad() {
      this.$sensors.track("LandingPage", {
        method: "download",
        pid: "A85",
        ldy_type: "original",
      });
      if (
        navigator.userAgent.match(/OS 16_[0-9] /i) ||
        navigator.userAgent.match(/OS 16_[0-9]_[0-9] /i)
      ) {
        //16及以上
        this.ios16 = true;
        this.doCopy();
        this.showRn = true;
      } else {
        //16以下
        this.doCopy();
        this.showRn = true;
      }
    },
    downloadRn() {
      this.$sensors.track("LandingPage", {
        method: "download",
        pid: "A85",
        ldy_type: "original",
        type: "RN",
      });
      this.doCopy();
      window.open(this.urlDate.ios_vest_url, "_self");
      this.matomoDownloadFunc('RN', this.urlDate.ios_vest_url);
    },
    // 获取code参数
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    doCopy() {
      let code = this.getUrlParam("code");
      let _text = `${this.urlDate.ios_vest_key}&code=${code}`;
      this.$copyText(_text)
        .then(() => {
          // this.$toast("复制成功");
        })
        .catch((er) => {
          this.$toast.fail("复制失败");
          console.err(er);
        });
    },
    showTips() {
      this.show = true;
    },
    updateCourseInfo(parmas) {
      this.courseInfo = { ...this.courseInfo, ...parmas };
    },
    choose(params) {
      this.show = false;
      this.updateCourseInfo({ phoneType: params });
    },
    otherPhoneInfoSet(params) {
      this.show = false;
      console.log(params);
      this.otherPhoneShow = params;
    },
    handDisp() {
      this.disp = false;
      this.disp2 = true;
      const that = this;
      setTimeout(function() {
        that.disp2 = false;
        that.disp = true;
        console.log(that.disp, "disppp");
      }, 3000);
    },
    tInstallOpen() {
      try {
        TInstall.setHost("https://api.tickshenqu.com");
        let params = TInstall.parseUrlParams();
        params.chan_key = window.chan_key;
        params.time_xytick = "" + Math.round(new Date() / 1000);
        let that = this;
        TInstall.getInstall("2NSBIO", params, function(res) {
          const ua = navigator.userAgent; //获取userAgent信息
          const md = new MobileDetect(ua); //实例化mobile-detect
          const os = md.os(); //获取系统
          //ios系统的处理
          if (os == "iOS") {
            // 埋点
            that.$sensors.track("LandingPage", {
              method: "download",
              pid: "A85",
              ldy_type: "original",
            });
            window.location.href = that.urlDate.ios_mdm_url;
          } else {
            //Android系统的处理
            that.$sensors.track("LandingPage", {
              method: "download",
              pid: "A85",
              type: "original",
            });
            if (!that.urlDate.landing_apk_link) {
              that.$toast("未配置下载包");
              that.refshData();
              return false;
            }
            that.$toast("正在下载…，请勿重复点击");
            console.log(that.urlDate.landing_apk_link);
            window.location.href = that.urlDate.landing_apk_link;
            that.matomoDownloadFunc('Apk', that.urlDate.android_download_url);
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    androidLoad() {
      this.$sensors.track("LandingPage", {
        method: "download",
        pid: "A85",
        type: "original",
      });
      window.location.href = this.urlDate.landing_apk_link;
    },
    // 下载
    ioslyLoad() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // isiOS isiOS
      if (isiOS) {
        // 埋点
        this.$sensors.track("LandingPage", {
          method: "download",
          pid: "A85",
          type: "MDM",
        });
        this.ycOne = true;
        this.handDisp();
        window.location.href = this.urlDate.ios_vest_url;
      } else {
        // 埋点
        this.$sensors.track("LandingPage", {
          method: "download",
          pid: "A85",
          type: "original",
        });
      }
    },
    matomoFunc() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // isiOS isiOS
      var _paq = (window._paq = window._paq || []);
      _paq.push([
        "setCustomDimension",
        1,
        window.location.hostname.replace("www.", ""),
      ]);
      _paq.push(["setCustomDimension", 2, document.title]);
      // 判定包类型
      let packageType;
      let packageLink;
      if (isiOS) {
        // if(this.urlDate.ldy_pwa.status == 1) {
        //   packageType = 'kFlutter';
        //   packageLink = this.urlDate.ldy_pwa.download_url;
        // }

        if(this.urlDate.ios_vest_url) {
          packageType = 'kRN';
          packageLink = this.urlDate.ios_vest_url;
        }
      } else {
        packageType = 'kApk';
        packageLink = this.urlDate.landing_apk_link;
      }
      _paq.push(['trackEvent',
          '框架加载', 
          packageType,          //kApk、kFlutter、kRN    (前面多加一个k来区分)
          packageLink]);
    },
    matomoDownloadFunc(type, link) {
      var _paq = (window._paq = window._paq || []);
      _paq.push(['setCustomDimension', 4, window.location.hostname.replace("www.", "")]);
      _paq.push(['setCustomDimension', 5, document.title]);
      _paq.push(['trackEvent', 
      '下载按钮', 
      type,          //Apk、Flutter、RN
      link]);   
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.van-popup__close-icon) {
  color: rgb(0, 0, 0);
}
:deep(.van-button) {
  flex: 1;
  width: 50%;
  height: 35px;
  margin: 0 0px 10px 0px; // 间隙为5px
  background-color: #ffffff;
  border-radius: 30px;
  text-align: center;
  line-height: 35px;
  min-width: 48%;
  max-width: 48%;
  font-weight: 700;
}
:deep(.van-swipe__indicator) {
  width: 116px;
  height: 2px;
  mix-blend-mode: normal;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.28);
  border-radius: 32px;
}
:deep(.van-swipe__indicator--active) {
  background: rgba(255, 255, 255, 1);
}
:deep(.van-swipe__indicators) {
  bottom: 50px;
  // position: absolute;
  // top: 97vh;
  // left: 75%;
}
.rn-pop {
  background-color: #333333;
}

.course_choose {
  overflow: hidden;
  padding: 0 15px;
  .course_and {
    padding-bottom: 0 !important;
    color: #323232 !important;
    text-align: center;
    .top_img {
      width: 211px;
      height: 59px;
    }
    .row {
      // width: 341px;
      height: 50px;
      margin: 10px auto;
      background-color: #f5f5f5;
      border: 2px solid;
      border-color: #e6e6e6;
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 14px;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #323232;
        font-size: 15px;
        // font-weight: 700;
        p {
          margin-left: 5px;
        }
      }
      img {
        width: 22px;
        height: 22px;
        object-fit: cover;
      }
      .shuoming-btn {
        width: 65px;
        height: 30px;
        background: linear-gradient(90deg, #f45a5a 0%, #e93535 99.02%);
        border-radius: 16px;
        text-align: center;
        line-height: 30px;
        color: #ffffff;
        font-size: 14px;
      }
    }
    .row.gap_b {
      border-radius: 10px;
      width: 297px;
      margin: 0 auto;
      padding: 15px 0;
      text-align: center;
      font-size: 12px;
      text-shadow: 0 0 8px rgba(255, 255, 255, 0.59);
    }
  }
}
.box {
  margin: 0;
  .weixin {
    height: 100vh;
    background-color: #000000;
    p {
      color: #ffffff;
      text-align: center;
    }
  }
  .content {
    // background-color: #071832;
    width: 100vw;
    height: 100vh;
    // background: url("./imgages2/h5_dbg@3x.png") center;
    // background-size: cover;
    .header {
      position: absolute;
      width: 100%;
      z-index: 98;
      > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        > div:nth-child(1) {
          padding-left: 20px;
          > img {
            height: 50px;
          }
        }
        > div:nth-child(2) {
          padding-top: 5px;
          padding-right: 26px;
          > img {
            height: 40px;
            vertical-align: middle;
          }
        }
      }
      > div:nth-child(2) {
        width: 100%;
        padding-top: 26px;
        > img {
          // width: 100%;
          margin: 0 auto;
          height: 50px;
        }
      }
    }
    .van-swipe-item {
      .title3 {
        // width: 350px;
        // width: 100%;
        // padding: 0 10px;
        img {
          width: 100%;
          height: 100%;
          // height: 463px;
          // margin: 0 auto;
          // object-fit: cover;
        }
      }
    }
  }
  @media screen and (max-height: 1070px) {
    /*兼容小屏 ：*/
    .content {
      .header {
        > div:nth-child(1) {
          padding-top: 15px;
          > div:nth-child(1) {
            padding-left: 20px;
            > img {
              height: 43px;
            }
          }
          > div:nth-child(2) {
            padding-top: 5px;
            padding-right: 26px;
            > img {
              height: 36px;
              vertical-align: middle;
            }
          }
        }
        > div:nth-child(2) {
          padding-top: 18px;
          > img {
            // width: 100%;
            margin: 0 auto;
            height: 40px;
          }
        }
      }
      .van-swipe-item {
        .title3 {
          // width: 350px;
          // width: 100%;
          // padding: 0 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  @media (device-height: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    /*兼容iphone6，iphone7，iphone8s ：*/
    .content {
      .header {
        > div:nth-child(1) {
          padding-top: 18px;
          > div:nth-child(1) {
            padding-left: 20px;
            > img {
              height: 43px;
            }
          }
          > div:nth-child(2) {
            padding-top: 5px;
            padding-right: 26px;
            > img {
              height: 36px;
              vertical-align: middle;
            }
          }
        }
        > div:nth-child(2) {
          padding-top: 18px;
          > img {
            // width: 100%;
            margin: 0 auto;
            height: 40px;
          }
        }
      }
      .van-swipe-item {
        .title3 {
          // width: 350px;
          // width: 100%;
          // padding: 0 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  @media (device-height: 736px) and (-webkit-min-device-pixel-ratio: 2) {
    /*兼容iphone6 Plus,iphone7 Plus,iphone8 Plus：*/
    .content {
      .header {
        > div:nth-child(1) {
          padding-top: 18px;
          > div:nth-child(1) {
            padding-left: 20px;
            > img {
              height: 43px;
            }
          }
          > div:nth-child(2) {
            padding-top: 5px;
            padding-right: 26px;
            > img {
              height: 36px;
              vertical-align: middle;
            }
          }
        }
        > div:nth-child(2) {
          padding-top: 18px;
          > img {
            // width: 100%;
            margin: 0 auto;
            height: 40px;
          }
        }
      }
      .van-swipe-item {
        .title3 {
          // width: 350px;
          // width: 100%;
          // padding: 0 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    /*兼容iphoneX*/
    .content {
      width: 100vw;
      height: 100vh;
      .header {
        position: absolute;
        width: 100%;
        z-index: 999;
        > div:nth-child(1) {
          display: flex;
          justify-content: space-between;
          padding-top: 20px;
          > div:nth-child(1) {
            padding-left: 20px;
            > img {
              height: 50px;
            }
          }
          > div:nth-child(2) {
            padding-top: 5px;
            padding-right: 26px;
            > img {
              height: 40px;
              vertical-align: middle;
            }
          }
        }
        > div:nth-child(2) {
          width: 100%;
          padding-top: 26px;
          > img {
            // width: 100%;
            margin: 0 auto;
            height: 50px;
          }
        }
      }
      .van-swipe-item {
        .title3 {
          // width: 350px;
          // width: 100%;
          // padding: 0 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .android-bottom {
    position: fixed;
    bottom: 5px;
    left: 0;
    right: 0;
    .download-btn {
      // width: 268px;
      height: 80px;
      // background-color: #ffffff;
      text-align: center;
      border-radius: 68px;
      margin: 0 auto;
      position: fixed;
      bottom: 55px;
      left: 0;
      right: 0;
      // background: url("./imgages2/h5_anljxz@3x.png") no-repeat;
      // background-size: cover;
      font-weight: 400;
      font-size: 20px;
      line-height: 79px;
      > button {
        width: 268px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
      }
      p {
        margin-left: 5px;
        font-size: 20px;
      }
      img {
        width: 268px;
        height: 80px;
      }
    }
    .download-ios {
      // width: 268px;
      height: 80px;
      // background-color: #ffffff;
      border-radius: 68px;
      margin: 0 auto;
      position: fixed;
      bottom: 55px;
      left: 0;
      right: 0;
      // background: url("./imgages2/App Store_Download_button@3x.png") no-repeat;
      // background-size: 100% 100%;
      text-align: center;
      font-weight: 400;
      font-size: 20px;
      line-height: 79px;
      > button {
        width: 170px;
        max-width: 48%;
        min-width: 170px;
        margin: 0 5px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
      }
      p {
        margin-left: 5px;
        font-size: 20px;
      }
      img {
        width: 268px;
        height: 80px;
      }
    }
    .tip {
      color: #ffffff;
      font-size: 14px;
      // display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
      img {
        vertical-align: middle;
        display: inline-block;
        width: 15px;
        height: 15px;
      }
    }
    .tip-ios {
      text-align: center;
      width: 24px;
      margin: 0 auto;
      &.abc {
        opacity: 0;
      }
    }
  }
  .ios-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(65, 60, 60, 0.6);
    display: flex;
    justify-content: space-between;
    padding: 10px 10px;
    border-bottom: 1px rgba(65, 60, 60, 0.6) solid;
    img {
      width: 118px;
      height: 48px;
      object-fit: cover;
    }
    .right {
      font-size: 12px;
      color: #ffffff;
      .fix-btn {
        margin-bottom: 5px;
        background-image: linear-gradient(270deg, #ed4a40 0%, #f28e3e 100%);
        width: 126px;
        height: 31px;
        text-align: center;
        line-height: 31px;
        border-radius: 15px;
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
}

.ios_down_list_view {
  border-radius: 20px 20px 0 0;
  padding-bottom: 20px;
  .ios_down_list_content {
    p {
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      margin: 15px 0;
    }
  }
  .message-box {
    text-align: center;
    img {
      width: 202px;
      height: 24px;
      margin: 0 auto;
    }
  }
  .list_item {
    width: 351px;
    height: 104px;
    box-sizing: border-box;
    margin: 15px auto 0;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      position: absolute;
      right: 20px;
      top: -6px;
      width: 87px;
      height: 20px;
      // background-image: url("./images/title-img.f8642671.png");
      background-size: 100% 100%;
      background-position: left center;
    }
  }
}
</style>
